import { BigTitle } from 'shared/components/BigTitle';
import { Block } from 'shared/components/Block';
import { Wrapper } from 'shared/components/Wrapper';
import { DESCRIPTION } from './constants';
import { Description } from 'shared/components/Description';

export const MainText: React.FC = () => {
  return (
    <div>
      <Wrapper withoutPaddingBottom>
        <Block>
          <BigTitle text="Бизнес-модель Циан" />
          <Description text={DESCRIPTION[0]} />
          <Description text={DESCRIPTION[1]} />
          <Description text={DESCRIPTION[2]} />
        </Block>
      </Wrapper>
    </div>
  );
};
